import { DatenTabelleWrapper } from '../assistent/items/wrapper/DatenTabelleWrapper';
import { getCustomFormConfigVsme } from '../custom/form_config_vsme';
import { IDs } from '../../../helpers/IDs';
import { isValid } from '../../../main/functions/validData';
import * as React from 'react';

export function getExtraFormElementVsme(entity: string, item: any, data: any, contextService?: any, filter?: any): any {
    const after: any = {};
    const before: any = {};
    data = data || {};
    filter = filter || {};
    item = item || {};

    switch (entity) {
        case IDs.ENT_VSME_B5: {
            const link: string = 'https://geodienste.bfn.de/schutzgebiete?lang=de&vm=2D&s=4562260.8284023665&r=0&c=540000%2C5720000&l=natura2000%281%2C2%29';
            after.schutzgebiet = (
                <div style={{ marginBottom: 20 }}>
                    <div>Link (externes Angebot): <a target='_blank' href={link}>Karte des Bundesamtes für Naturschutz</a></div>
                </div>
            );
            break;
        }
        case IDs.ENT_VSME_B10: {
            after.bildung = (
                <div style={{ marginTop: 5, marginBottom: 20 }}>
                    Geben Sie hier bitte die durchschnittliche Anzahl der Aus-, Fort- und Weiterbildungsstunden Ihrer Mitarbeiter an;
                    erfassen Sie dies bitte getrennt nach Geschlecht.
                </div>
            );
            break;
        }
        case IDs.ENT_VSME_BPM3: {
            if (!item.standort_tid || !item.jahr) {
                break;
            }
            const config: any = getCustomFormConfigVsme(entity, item, data) || {};
            const onClose = (): void => {
                contextService.set(IDs.CONTEXT_KEYS.AssistentConfigBpm3Dialog,`${filter.jahr}.${isValid(item, entity, data)}`);
            };
            if (!(config.titel_scope1 || {}).disableExtraElement) {
                after.titel_scope1 = (
                    <div style={{ marginBottom: 20 }}>
                        <DatenTabelleWrapper
                            configTable={{
                                entity: IDs.ENT_VSME_BPM3_SCOPE1,
                                module: IDs.MOD_ETOOL,
                                preFilter: { standort_tid: item.standort_tid_orig, jahr: item.jahr },
                                actions: ['add', 'edit', 'delete'],
                                columnWidths: [null, null, 180, 150, 180, 150, 180, 150]
                            }}
                            configButton={{
                                label: 'Minderungsziel hinzufügen',
                                insideText: 'Minderungsziel hinzufügen'
                            }}
                            onClose={() => onClose()}
                        />
                    </div>
                );
            }
            if (!(config.titel_scope2 || {}).disableExtraElement) {
                after.titel_scope2 = (
                    <div style={{ marginBottom: 20 }}>
                        <DatenTabelleWrapper
                            configTable={{
                                entity: IDs.ENT_VSME_BPM3_SCOPE2,
                                module: IDs.MOD_ETOOL,
                                preFilter: { standort_tid: item.standort_tid_orig, jahr: item.jahr },
                                actions: ['add', 'edit', 'delete'],
                                columnWidths: [null, null, 180, 150, 180, 150, 180, 150]
                            }}
                            configButton={{
                                label: 'Minderungsziel hinzufügen',
                                insideText: 'Minderungsziel hinzufügen'
                            }}
                            onClose={() => onClose()}
                        />
                    </div>
                );
            }
        }
        case IDs.ENT_VSME_BPM5: {
            if (item.standort_tid && item.jahr) {
                const config: any = getCustomFormConfigVsme(entity, item, data) || {};
                if (!(config.titel_c || {}).disableExtraElement) {
                    after.titel_c = (
                        <div style={{ marginBottom: 20 }}>
                            <DatenTabelleWrapper
                                configTable={{
                                    entity: IDs.ENT_VSME_BPM5_C,
                                    module: IDs.MOD_ETOOL,
                                    preFilter: { standort_tid: item.standort_tid_orig, jahr: item.jahr },
                                    actions: ['add', 'edit', 'delete']
                                }}
                                configButton={{
                                    label: 'Vermögenswert hinzufügen',
                                    insideText: 'Vermögenswert hinzufügen'
                                }}
                            />
                        </div>
                    );
                }
                if (!(config.titel_e || {}).disableExtraElement) {
                    after.titel_e = (
                        <div style={{ marginBottom: 20 }}>
                            <DatenTabelleWrapper
                                configTable={{
                                    entity: IDs.ENT_VSME_BPM5_E,
                                    module: IDs.MOD_ETOOL,
                                    preFilter: { standort_tid: item.standort_tid_orig, jahr: item.jahr },
                                    actions: ['add', 'edit', 'delete']
                                }}
                                configButton={{
                                    label: 'Immobilie hinzufügen',
                                    insideText: 'Immobilie hinzufügen'
                                }}
                            />
                        </div>
                    );
                }
            }
            break;
        }
    };

    return {
        ...(Object.keys(after).length && { extraFormElementAfter: after }),
        ...(Object.keys(before).length && { extraFormElementBefore: before })
    };
}
